
import {
  defineComponent,
  ref,
  computed,
  reactive,
} from 'vue';
import { addKey } from '@/api/monitor-center-kt';
import type { IAddKey } from '@/api/monitor-center-kt/type.d';
import { ElMessage } from 'element-plus';
import { DATA_TYPE_ENUM, DATA_TYPE_LIST } from '@/constant/monitor-center';
import KeyTips from './key-tips.vue';

export default defineComponent({
  name: 'AddKey',
  components: {
    KeyTips,
  },
  emits: ['update:visible', 'handleOperateSuccess'],
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
  },
  setup(props, { emit }) {
    const selfVisible = computed({
      get() {
        return props.visible;
      },
      set(val: boolean) {
        emit('update:visible', val);
      },
    });

    const formRef = ref();

    const formData = reactive<IAddKey>({
      key: '',
      redisDataType: '',
      value: '',
      ttl: '-1',
    });

    const handleClose = () => {
      selfVisible.value = false;
      formRef.value.resetFields();
    };

    const handleSave = async () => {
      await formRef.value.validate();
      await addKey(formData);
      ElMessage.success('操作成功！');
      handleClose();
      emit('handleOperateSuccess');
    };

    const valuePlaceholder = ref('请输入...');
    const redisDataTypeChange = () => {
      formData.value = '';
      switch (formData.redisDataType) {
        case DATA_TYPE_ENUM.HASH:
          valuePlaceholder.value = '{"key1":"value1","key2":"value2"........}';
          break;
        case DATA_TYPE_ENUM.SET:
          valuePlaceholder.value = '["XXX","XXX"........]';
          break;
        case DATA_TYPE_ENUM.ZSET:
          valuePlaceholder.value = '{"value1":"1.1","value2":"5"........}';
          break;
        case DATA_TYPE_ENUM.LIST:
          valuePlaceholder.value = '["XXX","XXX".......]';
          break;
        default:
          valuePlaceholder.value = '请输入...';
          break;
      }
    };

    return {
      formRef,
      formData,
      selfVisible,
      rules: {
        key: [
          { required: true, message: '请输入key', trigger: 'blur' },
        ],
        redisDataType: [
          { required: true, message: '请选择redisDataType', trigger: 'blur' },
        ],
        value: [
          { required: true, message: '请输入value', trigger: 'blur' },
        ],
        ttl: [
          { required: true, message: '请输入ttl', trigger: 'blur' },
        ],
      },
      handleClose,
      handleSave,
      DATA_TYPE_LIST,
      redisDataTypeChange,
      valuePlaceholder,
    };
  },
});
